import React from 'react';
import {connect} from 'react-redux';
import lifecycle from 'recompose/lifecycle';
import compose from 'recompose/compose';
import * as ResourceApi from "api/resources";
import {getAllResourcesAction} from "resources/actions";
import {filterOptionsFactory, sortOptionsFactory} from "viewOptions/factories";
import AutoSaveDropdown from 'components/forms/AutoSaveFormFields/AutoSaveDropdown';

import {isNullOrUndefined} from "utils/DBUtils";


import {createResourceTypeSelector} from "resources/selectors";

const getSiteItems = createResourceTypeSelector(ResourceApi.Types.Site);

const mapStateToProps = (state) => {
    
    console.log(`SiteDropdownConnected mapStateToProps`, state)

    let siteResources = Object.entries(state.sites.resources).map(([key, value]) => {return value})


    let options = siteResources.filter((site, i) => {
        return !isNullOrUndefined(site.label)
    }).map(site => {
        return {
          value: site.id,
          text: site.label
        };
      });



    // console.log(`mapStateToProps 1`, state)
    // console.log(`mapStateToProps 2`, getSiteItems(state.resources))
    return ({
        // sites: getSiteItems(state.resources)
        options: options
    })
}

const mapDispatchToProps = (dispatch) => ({
    getSites: () => dispatch(getAllResourcesAction(ResourceApi.Types.Site, sortOptionsFactory(),   
                                    filterOptionsFactory({
                                        // filters: [
                                        // {
                                        //     field: 'site',
                                        //     value: 'HALLMAN'
                                        // }
                                        // ]
                                    })
    ))
});

const SiteDropdownConnected = connect(mapStateToProps, mapDispatchToProps);

const SiteLifecycle = lifecycle({
    componentDidMount: function() {
        // this.props.getSites();
    }
});

const SiteDropdownComposed = compose(
    SiteDropdownConnected,
    SiteLifecycle
)(AutoSaveDropdown)

export default SiteDropdownComposed



// WEBPACK FOOTER //
// ./public/components/composites/BreakSiteSiteConnected.jsx